module.exports = __webpack_public_path__ + "img/icon_input_linkedin.cb9e7b6.svg";